import * as React from "react";

interface ICourse{
    img: string,
    name: string,
    hours: string | number,
    lessons: string | number,
    content: string
}

export default class CourseItem extends React.Component<ICourse, any>{
    constructor(props: ICourse){
        super(props);
    }
    render(){
        return (
            <div className="CourseItem">
                <img className='CourseItem__logo' src={`assets/images/courses/${this.props.img}`} alt={this.props.img} />
                <p className='CourseItem__name'><b>{this.props.name} Course</b></p>
                <div className="CourseItem__left">
                    <img src="assets/images/clock.png" alt="clock" />
                    <span>{this.props.hours} hours</span>
                </div>
                <div className="CourseItem__right">
                    <img src="assets/images/book.png" alt="clock" />
                    <span>{this.props.lessons} lessons</span>
                </div>
                <p className='CourseItem__content'>{this.props.content}</p>
                <div>
                    <button className='CourseItem__button'>
                        Go to course <span className='CourseItem__button__goto'>></span>
                    </button>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/homepage/CourseItem.tsx